import request from '@/utils/request'
//=================系统分类====start===================//

// 系统分类模板下载
export function downloadCategoryTemplate(data) {
  return request({
    url: '/config/get',
    method: 'post',
    data
  })
}

// 系统分类list
export function getCategoryList(data) {
  return request({
    url: '/product/cate/list',
    method: 'post',
    data
  })
}

// 新增系统分类
export function addCategory(data) {
  return request({
    url: '/product/category/add',
    method: 'post',
    data
  })
}

// 修改系统分类
export function editCategory(data) {
  return request({
    url: '/product/category/update',
    method: 'post',
    data
  })
}

// 审核系统分类
export function authCategorySuccess(data) {
  return request({
    url: '/product/category/audit/approval',
    method: 'post',
    data
  })
}

export function authCategoryFailed(data) {
  return request({
    url: '/product/category/audit/failed',
    method: 'post',
    data
  })
}

// 启用系统分类
export function enableCategory(data) {
  return request({
    url: '/product/category/enable',
    method: 'post',
    data
  })
}

// 禁用系统分类
export function disableCategory(data) {
  return request({
    url: '/product/category/disable',
    method: 'post',
    data
  })
}

// 删除系统分类
export function deleteCategory(data) {
  return request({
    url: '/product/category/delete',
    method: 'post',
    data
  })
}


// 获取系统分类详情
export function getCategoryDetail(data) {
  return request({
    url: '/product/category/detail',
    method: 'post',
    data
  })
}


//=================虚拟分类====start===================//
// 获取虚拟分类list
export function getVirtualCategoryList(data) {
  return request({
    url: '/product/virtual/category/list',
    method: 'post',
    data
  })
}

// 新增虚拟分类
export function addVirtualCategory(data) {
  return request({
    url: '/product/virtual/category/create',
    method: 'post',
    data
  })
}

// 修改虚拟分类
export function editVirtualCategory(data) {
  return request({
    url: '/product/virtual/category/modify',
    method: 'post',
    data
  })
}

// 启用虚拟分类
export function enabledVirtualCategory(data) {
  return request({
    url: '/product/virtual/category/enabled',
    method: 'post',
    data
  })
}

// 禁用虚拟分类
export function disableVirtualCategory(data) {
  return request({
    url: '/product/virtual/category/disable',
    method: 'post',
    data
  })
}

// 删除虚拟分类
export function deleteVirtualCategory(data) {
  return request({
    url: '/product/virtual/category/delete',
    method: 'post',
    data
  })
}

// 上移虚拟分类
export function upVirtualCategory(data) {
  return request({
    url: '/product/virtual/category/up',
    method: 'post',
    data
  })
}

// 下移虚拟分类
export function downVirtualCategory(data) {
  return request({
    url: '/product/virtual/category/down',
    method: 'post',
    data
  })
}

// 置顶虚拟分类
export function topVirtualCategory(data) {
  return request({
    url: '/product/virtual/category/top',
    method: 'post',
    data
  })
}

// 置底虚拟分类
export function bottomVirtualCategory(data) {
  return request({
    url: '/product/virtual/category/bottom',
    method: 'post',
    data
  })
}

// 获取虚拟分类详情
export function getVirtualCategoryDetail(data) {
  return request({
    url: '/product/virtual/category/detail',
    method: 'post',
    data
  })
}

// 获取虚拟分类 添加商品list
export function getProductList(data) {
  return request({
    url: '/product/spu/list',
    method: 'post',
    data
  })
}

// 导入商品分类
export function importCategory(data) {
  return request({
    url: '/product/category/import',
    method: 'post',
    data
  })
}

// 导出系统分类
export function categoryExport(data) {
  return request({
    url: '/product/category/export',
    method: 'post',
    data,
		responseType: 'arraybuffer'
  })
}




// WEBPACK FOOTER //
// ./src/api/category.js